module.exports = __webpack_public_path__ + "static/media/banner-principal.0b070f7f.png";